import {CuratorialGroupActionType, CuratorialGroupState} from "./types";

const initialState: CuratorialGroupState = {
    allGroups: null,
    group: null,
    loading: false,
    message: "",
};
const CuratorialGroupReducer = (state = initialState, action: any): CuratorialGroupState => {
    switch (action.type) {
        case CuratorialGroupActionType.START_REQUEST:
            return { ...state, loading: true };
        case CuratorialGroupActionType.ALL_GROUPS_LOADED:
            return { ...state, loading: false, allGroups: action.payload };
        case CuratorialGroupActionType.GROUP_LOADED:
            return { ...state, loading: false, group: action.payload };
        case CuratorialGroupActionType.FINISH_REQUEST:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default CuratorialGroupReducer;
